import { InboxIcon } from '@heroicons/react/24/outline'
import React from 'react'

interface EmptyResponseProps {
  isVisible: boolean
}

export const EmptyResponse = ({ isVisible = false }: EmptyResponseProps) => {
  if (!isVisible) {
    return null
  }

  return (
    <div className="px-6 py-14 text-center sm:px-14">
      <InboxIcon className="mx-auto text-gray-400 size-6" aria-hidden="true" data-testid="inbox-icon" />
      <p className="mt-4 text-sm text-night">
        Nous n&apos;avons pas trouvé de résultats pour votre recherche.
      </p>
    </div>
  )
}
